import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";


import {
  GET_CHANGE_LOG_PENDING,
  GET_CHANGE_LOG,
  SG_GET_CHANGE_LOG,
  DELETE_CHANGE_LOG,
  SG_DELETE_CHANGE_LOG,
  FETCH_CHANGE_LOG,
  SG_FETCH_CHANGE_LOG,
  EDIT_CHANGE_LOG,
  SG_EDIT_CHANGE_LOG,
  ADD_CHANGE_LOG,
  SG_ADD_CHANGE_LOG,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadmethods(action) {
    yield put({ type: GET_CHANGE_LOG_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_CHANGE_LOG, action.payload);
    // console.log(json.data)
    yield put({ type: GET_CHANGE_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeEvery(SG_GET_CHANGE_LOG, loadmethods);
}


function* fetchmethods(action) {
    yield put({ type: GET_CHANGE_LOG_PENDING });
  try {
    const json = yield call(api.FETCH_CHANGE_LOG, action.payload);
    yield put({ type: FETCH_CHANGE_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_CHANGE_LOG, fetchmethods);
}


function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_CHANGE_LOG, action.payload);
    yield put({ type: EDIT_CHANGE_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_CHANGE_LOG, updatemethods);
}

function* addmethods(action) {
  // RESET_ADD_ACTIVE_PAGE_GPT_MEMBER
  try {
    const json = yield call(api.ADD_CHANGE_LOG, action.payload);
    yield put({ type: ADD_CHANGE_LOG, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_CHANGE_LOG, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_CHANGE_LOG, action.payload);
    yield put({ type: DELETE_CHANGE_LOG, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_CHANGE_LOG, deletemethods);
}

export default function* index() {
  yield all([
    methodLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
